import { Field } from 'redux-form';
import ComboboxField from './Combobox';

const ComboboxInput = (props) => {
  const {id, name, type, typeName, order, options, required} = props;
  return ( 
    <div>
      <Field
        id={id}
        name={name}
        typeName={typeName}
        order={order}
        values={options}
        required={required}
        component={ComboboxField}
      />
    </div>
  );
}

export default ComboboxInput;